










































































import * as _ from "lodash";
import moment from "moment";
import { Prop, Component, Vue } from 'vue-property-decorator';
import firebase from "firebase";
import * as F from "@/models/koto"
import { Marked, MarkedOptions } from 'marked-ts'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import * as Auth from "@/models/auth";
extend('required', required);

@Component({
  components: {
    ValidationProvider, ValidationObserver,
  }
})
export default class Koto extends Vue {

  @Prop() auth_state!: Auth.AuthState

  // -- util --
  timeout(epoch_ms: number, format: string) {
    return moment(epoch_ms).format(format);
  }

  // -- new Koto --
  show_new_koto = false;
  newKoto: F.Koto = F.Koto.spawn();
  new_mode: "view" | "edit" = "edit";
  edit_new_koto() {
    this.new_mode = "edit";
    this.show_new_koto = true;
  }

  get newKotoHTML(): string {
    const option = new MarkedOptions()
    option.gfm = true
    // option.breaks = true
    return Marked.parse(this.newKoto.body, option);
  }

  get newKotoError() {
    return F.Koto.validate_update(this.newKoto);
  }


  async post_koto(object: F.Koto) {
    if (!object) { return; }
    await this.lister.save(object);
    this.show_new_koto = false;
    this.newKoto = F.Koto.spawn();
  }

  async patch_koto(object: F.Koto) {
    if (!object) { return; }
    await this.lister.save(object);
    this.show_existing_koto = false;
    this.existing_mode = "view";
  }

  async delete_koto(object: F.Koto) {
    if (!object) { return; }
    if (!confirm("削除します。よろしいですか？")){ return; }
    await this.lister.delete(object);
    this.show_existing_koto = false;
    this.existing_mode = "view";
  }

  // -- existing Koto --
  show_existing_koto = false;
  existing_mode: "view" | "edit" = "view";
  selectedKoto: F.Koto | null = null;
  view_koto(koto: F.Koto) {
    this.selectedKoto = F.Koto.copy(koto);
    this.existing_mode = "view";
    this.show_existing_koto = true;
  }

  get selectedKotoHTML(): string {
    if (!this.selectedKoto) { return "" }
    const option = new MarkedOptions()
    option.gfm = true
    // option.breaks = true
    return Marked.parse(this.selectedKoto.body, option);
  }

  get selectedKotoError() {
    return F.Koto.validate_update(this.selectedKoto ? this.selectedKoto : undefined);
  }

  // -- Kotos IO --
  lister!: F.KotoLister;
  unsubscriber!: () => void;
  docs: F.Koto[] = [];
  koto_working = false;

  // -- LifeCycle Hooks --
  async mounted() {

    // -- lister --
    // setup
    this.lister = F.Koto.lister("_testuser_");
    this.lister.option.saveStatusCallback = (status) => this.koto_working = status === "working";
    this.lister.option.snapshotCallback = (change) => {
      const { doc, object } = change;
      // console.log(`[!!] ${change.type} ${change.object.id}`)
      switch (change.type) {
      case "added":
      case "modified":
        (() => {
          const i = this.docs.findIndex((d) => d.id === doc.id)
          if (0 <= i) {
            this.docs.splice(i, 1, object);
          } else {
            this.docs.splice(0, 0, object);
          }
        })()
        break;
      case "removed":
        (() => {
          const i = this.docs.findIndex((d) => d.id === doc.id);
          if (0 <= i) {
            this.docs.splice(i, 1);
          }
        })();
        break;
      }
    };

    // fetch
    (await this.lister.fetch()).forEach((d) => this.docs.push(d));
    this.unsubscriber = this.lister.snapshot();
  }
}
